export const retainConstants = {
    GET_COMPANY_RETAIN_CAMPAIGNS_REQUEST: 'GET_COMPANY_RETAIN_CAMPAIGNS_REQUEST',
    GET_COMPANY_RETAIN_CAMPAIGNS_SUCCESS: 'GET_COMPANY_RETAIN_CAMPAIGNS_SUCCESS',
    GET_COMPANY_RETAIN_CAMPAIGNS_FAILURE: 'GET_COMPANY_RETAIN_CAMPAIGNS_FAILURE',

    GET_COMPANY_RETAIN_METRICS_REQUEST: 'GET_COMPANY_RETAIN_METRICS_REQUEST',
    GET_COMPANY_RETAIN_METRICS_SUCCESS: 'GET_COMPANY_RETAIN_METRICS_SUCCESS',
    GET_COMPANY_RETAIN_METRICS_FAILURE: 'GET_COMPANY_RETAIN_METRICS_FAILURE',

    GET_ORGANIZATION_RETAIN_CAMPAIGNS_REQUEST: 'GET_ORGANIZATION_RETAIN_CAMPAIGNS_REQUEST',
    GET_ORGANIZATION_RETAIN_CAMPAIGNS_SUCCESS: 'GET_ORGANIZATION_RETAIN_CAMPAIGNS_SUCCESS',
    GET_ORGANIZATION_RETAIN_CAMPAIGNS_FAILURE: 'GET_ORGANIZATION_RETAIN_CAMPAIGNS_FAILURE',

    GET_ORGANIZATION_RETAIN_METRICS_REQUEST: 'GET_ORGANIZATION_RETAIN_METRICS_REQUEST',
    GET_ORGANIZATION_RETAIN_METRICS_SUCCESS: 'GET_ORGANIZATION_RETAIN_METRICS_SUCCESS',
    GET_ORGANIZATION_RETAIN_METRICS_FAILURE: 'GET_ORGANIZATION_RETAIN_METRICS_FAILURE',

    GET_SINGLE_RETAIN_CAMPAIGN_METRICS_REQUEST: 'GET_SINGLE_RETAIN_CAMPAIGN_METRICS_REQUEST',
    GET_SINGLE_RETAIN_CAMPAIGN_METRICS_SUCCESS: 'GET_SINGLE_RETAIN_CAMPAIGN_METRICS_SUCCESS',
    GET_SINGLE_RETAIN_CAMPAIGN_METRICS_FAILURE: 'GET_SINGLE_RETAIN_CAMPAIGN_METRICS_FAILURE',

    GET_CAMPAIGN_ATTRIBUTION_METRICS_REQUEST: 'GET_CAMPAIGN_ATTRIBUTION_METRICS_REQUEST',
    GET_CAMPAIGN_ATTRIBUTION_METRICS_SUCCESS: 'GET_CAMPAIGN_ATTRIBUTION_METRICS_SUCCESS',
    GET_CAMPAIGN_ATTRIBUTION_METRICS_FAILURE: 'GET_CAMPAIGN_ATTRIBUTION_METRICS_FAILURE',

    GET_CAMPAIGN_SUMMARY_REPORT_REQUEST: 'GET_CAMPAIGN_SUMMARY_REPORT_REQUEST',
    GET_CAMPAIGN_SUMMARY_REPORT_SUCCESS: 'GET_CAMPAIGN_SUMMARY_REPORT_SUCCESS',
    GET_CAMPAIGN_SUMMARY_REPORT_FAILURE: 'GET_CAMPAIGN_SUMMARY_REPORT_FAILURE',
    GET_CAMPAIGN_SUMMARY_REPORT_NOT_FOUND: 'GET_CAMPAIGN_SUMMARY_REPORT_NOT_FOUND',
}